import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DbCredModel } from '../models/classes/db-cred';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class ConnectionService {
  ip = environment.ipServer;
  private userUrl = `${this.ip}/api/DbCredential`;
  schema: BehaviorSubject<number>;
  hasAdded: number;
  
  constructor(private http: HttpClient) {
    this.schema = new BehaviorSubject<number>(null);
  }

  addCredential(credential: DbCredModel): Observable<any> {
    return this.http.post(this.userUrl, credential);
  }

  availableSchemas(): Observable<string[]> {
    let url = `${this.ip}/api/DbCredential/GetDbCredential`;
    return this.http.get<string[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  authentificateSchema(baseUrl: string, schema: string): Observable<number> {
    let urls = `${this.ip}/api/DbCredential/GetConnectionString`;
    let url = `${urls}/${schema}`;

    return this.http.get<number>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }
  get schemaId(): Observable<number> {
    return this.schema.asObservable();
  }

  connectionCheck(){
    let urls = `${this.ip}/api/DbCredential/ConnectionCheck`;
    return this.http.get(urls).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
